import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const Login = () => import("views/login/index");
// 导入登录表单页面
const FormPage = () => import("views/login/formPage");
const PhoneCodeLogin = () => import("views/login/phoneCode");
const Home = () => import("views/home");
const apply = () => import("views/apply");
const Donate = () => import("views/donate/indexNew");
const Teamwork = () => import("views/teamwork");
const UserCenter = () => import("views/userCenter");
const Other = () => import("views/other");
const UserInfo = () => import("views/userCenter/userInfo");
const Send = () => import("views/userCenter/send");
const About = () => import("views/cms/about");
const Guidelines = () => import("views/cms/guidelines");
const Support = () => import("views/cms/support");
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/formPage",
    component: FormPage,
  },
  {
    path: "/phoneCodeLogin",
    component: PhoneCodeLogin,
  },

  {
    path: "/home",
    component: Home,
    meta: { keepAlive: true },
  },
  {
    path: "/apply",
    component: apply,
  },
  {
    path: "/donate",
    component: Donate,
  },
  {
    path: "/donateSecond",
    component: () => import("views/donate/second"),
    // meta: { keepAlive: true },
  },
  {
    path: "/donateThird",
    component: () => import("views/donate/third"),
  },
  {
    path: "/teamwork",
    component: Teamwork,
  },
  {
    path: "/userCenter",
    component: UserCenter,
  },
  {
    path: "/userCenterSecond",
    component: () => import("views/userCenter/second"),
  },
  {
    path: "/userCenterThird",
    component: () => import("views/userCenter/third"),
  },
  {
    path: "/other",
    component: Other,
  },
  {
    path: "/userInfo",
    component: UserInfo,
  },
  {
    path: "/send",
    component: Send,
  },
  {
    path: "/about",
    component: About,
  },
  {
    path: "/guidelines",
    component: Guidelines,
  },
  {
    path: "/support",
    component: Support,
  },
  {
    path: '/becomePartner',
    component: () => import('../views/cms/becomePartner.vue')
  },
  {
    path: '/cmsIndex',
    component: () => import('../views/cms/cmsIndex.vue')
  }
];

const whiteList = ["/login", "/about", "/guidelines", "/support"];

const router = new VueRouter({
  routes,
  mode: "history",
});
export { whiteList };
export default router;
